import React, { createContext, useContext, ReactNode } from 'react'

export interface Theme {
  button: {
    chromeless: Record<string, any>
    secondary: Record<string, any>
    common: {
      backgroundColor: string
      color: string
    }
  }
}

const defaultTheme: Theme = {
  button: {
    chromeless: {},
    secondary: {},
    common: {
      backgroundColor: 'red',
      color: 'white',
    },
  },
}

export const ThemeContext = createContext<Theme>(defaultTheme)

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return context
}

export const configureAppTheme = (theme: Partial<Theme>): Theme => {
  return {
    button: {
      chromeless: theme.button?.chromeless || {},
      secondary: theme.button?.secondary || {},
      common: {
        backgroundColor: theme.button?.common?.backgroundColor || 'red',
        color: theme.button?.common?.color || 'white',
      },
    },
  }
}

interface ThemeProviderProps {
  children: ReactNode
  theme: Theme
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children, theme }) => {
  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  )
}
